module.exports = __webpack_public_path__ + "static/case_gabriel-cc8a276f591e5942711997f1a5af23f3.jpg";